import { Pill } from '@/utils/render'

export type PaymentChannelStatus = 'disabled' | 'partial' | 'ready'

interface Props {
  status: PaymentChannelStatus
  label?: string
}

const STATUS_MAP: Record<PaymentChannelStatus, { variant: 'neutral' | 'warning' | 'success'; text: string }> = {
  disabled: { variant: 'neutral', text: '未配置' },
  partial: { variant: 'warning', text: '配置不完整' },
  ready: { variant: 'success', text: '已就绪' },
}

export default function PaymentStatusPill({ status, label }: Props) {
  const meta = STATUS_MAP[status]
  return <Pill variant={meta.variant}>{label ?? meta.text}</Pill>
}
